import { render, staticRenderFns } from "./StepsPanelWrapper.vue?vue&type=template&id=3a8412a5&scoped=true"
import script from "./StepsPanelWrapper.vue?vue&type=script&lang=js"
export * from "./StepsPanelWrapper.vue?vue&type=script&lang=js"
import style0 from "./StepsPanelWrapper.vue?vue&type=style&index=0&id=3a8412a5&prod&scoped=true&lang=css"
import style1 from "./StepsPanelWrapper.vue?vue&type=style&index=1&id=3a8412a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8412a5",
  null
  
)

export default component.exports